import api from './api'
import { Quote, Modality, CreateQuoteData, QuoteFilters } from '../types/quote'

/**
 * Obter todas as modalidades disponíveis
 */
export async function getModalities(): Promise<Modality[]> {
  const response = await api.get('/quotes/modalities')
  return response.data
}

/**
 * Criar nova cotação
 */
export async function createQuote(data: CreateQuoteData): Promise<Quote> {
  const response = await api.post('/quotes', data)
  return response.data.quote
}

/**
 * Listar cotações
 */
export async function listQuotes(filters?: QuoteFilters): Promise<Quote[]> {
  const params = new URLSearchParams()

  if (filters?.status) params.append('status', filters.status)
  if (filters?.year) params.append('year', filters.year.toString())
  if (filters?.search) params.append('search', filters.search)

  const queryString = params.toString()
  const response = await api.get(`/quotes${queryString ? `?${queryString}` : ''}`)
  return response.data
}

/**
 * Obter cotação por ID
 */
export async function getQuote(id: string): Promise<Quote> {
  const response = await api.get(`/quotes/${id}`)
  return response.data
}

/**
 * Atualizar cotação
 */
export async function updateQuote(id: string, data: Partial<CreateQuoteData>): Promise<Quote> {
  const response = await api.patch(`/quotes/${id}`, data)
  return response.data.quote
}

/**
 * Deletar cotação
 */
export async function deleteQuote(id: string): Promise<void> {
  await api.delete(`/quotes/${id}`)
}

/**
 * Ativar cotação (disponibilizar para freight forwarders)
 */
export async function activateQuote(id: string): Promise<Quote> {
  const response = await api.post(`/quotes/${id}/activate`)
  return response.data.quote
}

/**
 * Cancelar cotação
 */
export async function cancelQuote(id: string, reason?: string): Promise<Quote> {
  const response = await api.post(`/quotes/${id}/cancel`, { reason })
  return response.data.quote
}

/**
 * Obter cotação para exportação (inclui dados do shipper)
 */
export async function getQuoteForExport(id: string): Promise<Quote & {
  shipper_name?: string
  shipper_trading_name?: string
  shipper_cnpj?: string
  shipper_logo_url?: string
}> {
  const response = await api.get(`/quotes/${id}/export`)
  return response.data.quote
}

/**
 * Duplicar cotação (criar nova com os mesmos dados)
 * A nova cotação é criada com status 'active' para já receber ofertas
 */
export async function duplicateQuote(id: string): Promise<Quote> {
  const response = await api.post(`/quotes/${id}/duplicate`)
  return response.data.quote
}
